import { useState, useEffect } from 'react';
import './App.css';
import './assets/css/style.css';
import './assets/css/contact-page.css';
import Home from './componets/Home';
import Contact from './componets/Contact';
import PrivacyPolicy from './componets/PrivacyPolicy';
import TermsAndCondition from './componets/TermsAndCondition';
import FAQ from './componets/FAQ';
import About from './componets/About';
import MobileOnlySlider from './componets/MobileOnlySlider';
import MobileOnlySliderLeft from './componets/MobileOnlySliderLeft';
import Footer from './componets/Footer';
import Header from './componets/Header';
import WhyChooseUs from './componets/WhyChooseUs';

function App() {
  const [currentPage, setCurrentPage] = useState('home');

  useEffect(() => {
    // Check hash on load
    const hash = window.location.hash;
    if (hash === '#contact') {
      setCurrentPage('contact');
    } else if (hash === '#privacy') {
      setCurrentPage('privacy');
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    } else if (hash === '#terms') {
      setCurrentPage('terms');
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    } else {
      setCurrentPage('home');
    }

    // Listen for hash changes
    const handleHashChange = () => {
      const newHash = window.location.hash;
      if (newHash === '#contact') {
        setCurrentPage('contact');
      } else if (newHash === '#privacy') {
        setCurrentPage('privacy');
        setTimeout(() => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 100);
      } else if (newHash === '#terms') {
        setCurrentPage('terms');
        setTimeout(() => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 100);
      } else {
        setCurrentPage('home');
      }
    };

    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  useEffect(() => {
    const revealSelector = [
      'h1',
      'h2',
      'h3',
      'h4',
      'h5',
      'h6',
      'p',
      'li',
      'blockquote',
      'label',
      'button',
      'a',
      '.about-badge',
      '.faq-badge',
      '.section-title',
      '.heading',
      '.lead',
      '.about-eyebrow',
      '.about-main-heading',
      '.about-story-kicker',
      '.about-text',
      '.about-feature-card',
      '.faq-main-heading',
      '.faq-question',
      '.faq-answer',
      '.contact-main-heading',
      '.contact-description',
      '.contact-subheading',
      '.contact-detail-item',
      '.contact-form-card',
      '.form-title',
      '.form-instruction',
      '.form-group',
      '.form-submit-btn',
      '.privacy-main-heading',
      '.privacy-section-title',
      '.privacy-date',
      '.privacy-subtitle',
      '.privacy-text',
      '.terms-main-heading',
      '.terms-section-title',
      '.terms-date',
      '.terms-subtitle',
      '.terms-text',
      '.terms-list'
    ].join(',');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.18,
      rootMargin: '0px'
    });

    const observeRevealItems = () => {
      document.querySelectorAll(revealSelector).forEach((element) => {
        if (!element.classList.contains('is-visible')) {
          element.classList.add('text-scroll-reveal');

          // Dynamic answers and end-of-page footer text should be visible immediately.
          if (
            element.matches('.faq-answer') ||
            element.closest('.faq-answer') ||
            element.closest('.footer-bottom')
          ) {
            element.classList.add('is-visible');
            return;
          }

          observer.observe(element);
        }
      });
    };

    observeRevealItems();

    const mutationObserver = new MutationObserver(observeRevealItems);
    mutationObserver.observe(document.body, { childList: true, subtree: true });

    return () => {
      observer.disconnect();
      mutationObserver.disconnect();
    };
  }, [currentPage]);

  const handleContactClick = (e) => {
    if (e && e.ctrlKey) {
      // If Ctrl/Cmd is pressed, let default behavior happen (open in new tab)
      return;
    }
    window.location.hash = '#contact';
    setCurrentPage('contact');
  };

  const handleHomeClick = () => {
    window.location.hash = '#home';
    setCurrentPage('home');
  };

  const getHeaderHeight = () => {
    const header = document.querySelector('.main-header');
    return header ? header.offsetHeight : 0;
  };

  const handleFAQClick = () => {
    // Scroll to FAQ section
    window.location.hash = '#home';
    setCurrentPage('home');
    setTimeout(() => {
      const faqSection = document.querySelector('.faq-section');
      if (faqSection) {
        const headerHeight = getHeaderHeight();
        const elementPosition = faqSection.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementPosition - headerHeight - 40;
        
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }, 100);
  };

  const handleContactNewTab = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setTimeout(() => {
      const currentUrl = window.location.origin + window.location.pathname + '#contact';
      window.open(currentUrl, '_self');
    }, 100);
  };

  const handlePrivacyClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setTimeout(() => {
      const currentUrl = window.location.origin + window.location.pathname + '#privacy';
      window.open(currentUrl, '_self');
    }, 100);
  };

  const handleTermsClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setTimeout(() => {
      const currentUrl = window.location.origin + window.location.pathname + '#terms';
      window.open(currentUrl, '_self');
    }, 100);
  };

  const renderPage = () => {
    switch (currentPage) {
      case 'contact':
        return <Contact />;
      case 'privacy':
        return <PrivacyPolicy />;
      case 'terms':
        return <TermsAndCondition />;
      default:
        return (
          <>
            <Home />
            <About />
            <main>
              <MobileOnlySlider />
            </main>
            <WhyChooseUs />
            <FAQ />
          </>
        );
    }
  };

  return (
    <>
      <Header onContactClick={handleContactNewTab} onHomeClick={handleHomeClick} onFAQClick={handleFAQClick} />
      {renderPage()}
      <Footer onContactClick={handleContactNewTab} onPrivacyClick={handlePrivacyClick} onTermsClick={handleTermsClick} />
    </>
  );
}

export default App;
